import { createContext } from 'react';
import PackageService from '../Services/PackageService';

const PackageServiceContext = createContext<PackageService>(new PackageService());

export default PackageServiceContext;
